import React from "react";
import { Product } from "../types";

type Props = {
  product: Product;
  onAddToCart?: (p: Product) => void;
  onViewDetails?: (p: Product) => void;
};

const cardStyle: React.CSSProperties = {
  background: "#1a1a1a",
  borderRadius: 12,
  padding: 12,
  border: "1px solid #2a2a2a",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 8,
};
const imageStyle: React.CSSProperties = {
  width: 120,
  height: 120,
  objectFit: "cover",
  borderRadius: 8,
};
const nameStyle: React.CSSProperties = {
  fontWeight: 600,
  color: "#fff",
  textAlign: "center",
  minHeight: 40,
};
const priceStyle: React.CSSProperties = {
  color: "#fff",
  fontWeight: 700,
};
const btnGroup: React.CSSProperties = {
  display: "flex",
  gap: 8,
  width: "100%",
};
const ghostBtn: React.CSSProperties = {
  flex: 1,
  padding: "8px 10px",
  borderRadius: 6,
  border: "1px solid #2a2a2a",
  background: "transparent",
  color: "#fff",
  cursor: "pointer",
};
const addBtn: React.CSSProperties = {
  ...ghostBtn,
  background: "#ff6b35",
  border: "none",
};

export const ProductCard: React.FC<Props> = ({
  product,
  onAddToCart,
  onViewDetails,
}) => {
  return (
    <div style={cardStyle} className="product-card">
      <img src={product.image} alt={product.name} style={imageStyle} />
      <div style={nameStyle}>{product.name}</div>
      <div style={priceStyle}>${product.price.toFixed(2)}</div>
      <div style={btnGroup}>
        <button style={ghostBtn} onClick={() => onViewDetails?.(product)}>
          Details
        </button>
        <button style={addBtn} onClick={() => onAddToCart?.(product)}>
          Add
        </button>
      </div>
    </div>
  );
};
